<div class="trade-todo">
  <div class="page-help-topics"><button pButton type="button" (click)="help.toggle($event)" class="icon-action" icon="fa fa-question-circle" pTooltip="View Help Topics" tooltipPosition="top"></button>
    <p-overlayPanel #help styleClass="page-help-interior">
      <h4><i class="fa fa-question-circle"></i> Help Topics</h4>
      <ul>
        <li><a (click)="helpDialogR()">How do I see an overview?</a></li>
        <li><a (click)="helpDialogS()">How do I add tasks?</a></li>
        <li><a (click)="helpDialogT()">How do I move &amp; update tasks?</a></li>
      </ul>
    </p-overlayPanel>
    <p-dialog header="Show Me | ToDos: Overview" [(visible)]="display17" [modal]="true" [responsive]="true">
      <iframe *ngIf="display17" width="560" height="315" src="https://www.youtube.com/embed/Uh-mugZLgeo?start=0;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | ToDos: Adding Tasks" [(visible)]="display18" [modal]="true" [responsive]="true">
      <iframe *ngIf="display18" width="560" height="315" src="https://www.youtube.com/embed/Uh-mugZLgeo?start=116;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </p-dialog>
    <p-dialog header="Show Me | ToDos: Moving &amp; Updating Tasks" [(visible)]="display19" [modal]="true" [responsive]="true">
      <iframe *ngIf="display19" width="560" height="315" src="https://www.youtube.com/embed/Uh-mugZLgeo?start=177;autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </p-dialog>
  </div>
  <div class="p-grid">
    <div class="p-col-12">

      <div align="right" style="padding-right:3%;">
        <button *ngIf="user?.info?.orgId == DefaultOrg.OrgId" class="action-secondary" type="button" (click)="showAddContainer()" label="Add Lane" [disabled]="containers.length >= maxNumOfLanes">
          <i class="fa fa-plus"></i> Add Lane</button>
        <button class="action-secondary" type="button" (click)="showAddWidget()" label="Add Task">
          <i class="fa fa-plus"></i> Add Task</button>
      </div>
      <div *ngIf="loadhtml">
        <div dnd-sortable-container [sortableData]="containers" [dropZones]="['container-dropZone']" class="todo-cols-wrapper">
          <div class="todo-cols" *ngFor="let container of containers; let c_i = index" dnd-sortable [sortableIndex]="c_i" [dragEnabled]="dragOperation" (onDropSuccess)="moveContainer(c_i)">
            <div class="panel panel-success" dnd-sortable-container [sortableData]="container.widgets" [dropZones]="['widget-dropZone']">
              <button *ngIf="user?.info?.orgId == DefaultOrg.OrgId" (click)="deleteContainer(c_i)" style="float:right;">
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
              <div class="panel-heading">
                <h5>
                  {{container.lane}}</h5>
              </div>

              <div class="panel-body">
                <ul class="list-group">
                  <li *ngFor="let widget of container.widgets; let w_i = index" class="list-group-item" dnd-sortable [sortableIndex]="w_i" [dragEnabled]="!dragOperation" (onDropSuccess)="moveWidget($event,c_i, w_i)"
                    [dragData]="widget">{{widget.title}}
                    <button (click)="showEditWidget(c_i, w_i)">
                      <i class="fa fa-pencil"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <h4 *ngIf="user?.info?.orgId == DefaultOrg.OrgId">
    <p-checkbox [(ngModel)]="dragOperation" binary="true" value="checkbox"></p-checkbox> Reorder Lanes
  </h4>
  <p-confirmDialog></p-confirmDialog>


  <!-- dialog for adding new widget -->
  <p-dialog styleClass="trade-dialogs" header="Manage Task" *ngIf="widget&&widgetDialog" [(visible)]="widgetDialog" [responsive]="true" [dismissableMask]="true"
            [modal]="true" [style]="DialogStyle40" [contentStyle]="{'overflow-y':'auto'}">

    <form #widgetForm="ngForm">

      <div class="p-grid">
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Title*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <input type="text" [(ngModel)]="widget.title" [maxlength]="Validation.ToDoTitle" pInputText id="title" name="title" required style="width:100%;">
          </div>
          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Lane*</label>
          </div>
          <div *ngIf="widget.id" class="p-col-12 p-md-8 p-lg-8">{{ widget.taskLaneName | titleCase }} </div>
          <div *ngIf="!widget.id"  class="p-col-12 p-md-8 p-lg-8" >
            <p-dropdown [placeholder]="Validation.DropdownPlaceholder"  [options]="containerDropdown" [(ngModel)]="laneSelected.id" id="laneName" name="laneName" (onChange)="onLaneSelect(laneSelected.id)"
            required></p-dropdown></div>

          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Due Date*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-calendar [dateFormat]="Format.PcalendarDate" [showIcon]="true" [(ngModel)]="widget.duedate" name="calendar" id="calendar" (onSelect)="dueDateSelected(widget.duedate)" [style]="{'overflow':'visible'}"
              required></p-calendar>
            <br>
            <p-checkbox binary="true" name="reminder" id="reminder" [(ngModel)]="widget.reminder"></p-checkbox> Send Reminder
          </div>

          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Enable Assigned-To User to Edit the Status*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">

            <p-checkbox binary="true" name="enableUserToChangeTODOStatus" id="enableUserToChangeTODOStatus" [(ngModel)]="widget.enableUserToChangeTODOStatus"></p-checkbox>
          </div>

          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Assigned To*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <p-autoComplete name="userName" class="autoComplete" field="fullName" [placeholder]="Validation.AutoCompletePlaceholder"
                            [suggestions]="suggestedUsers" [minLength]="Validation.AutoCompleteMinLength" [showEmptyMessage]="true" [dropdown]="true"
                            (completeMethod)="searchUser(selectedUser)"
                            [(ngModel)]="selectedUser" (onSelect)="userSelected(selectedUser)"></p-autoComplete>
          </div>

          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Description*</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <textarea [rows]="5" [cols]="20" [maxlength]="Validation.ToDoDescription" style="height:75px !important;width:100%;" [(ngModel)]="widget.description" pInputText id="description" name="description"
              required pInputTextarea></textarea>
          </div>

          <div class="p-col-12 p-md-4 p-lg-4">
            <label>Comments</label>
          </div>
          <div class="p-col-12 p-md-8 p-lg-8">
            <textarea pInputTextarea [(ngModel)]="comment.comment" [rows]="5" [cols]="20" maxlength="200" style="height:75px !important;width:100%;" name="comment" id="comment" placeholder="Enter your text here"> </textarea>
          </div>

        <div *ngIf="widget.id" class="p-col-12" style="margin-top:20px;border:1px solid #ccc;background-color:#efefef;">
          <h5>Comment History</h5>
          <ul id="unstyled">
            <li *ngFor="let c of  widget.taskTodoComments">
              <strong>{{c.userFullName}}</strong> {{c.displayCreatedOn| date:'medium'}}
              <textarea pInputTextarea [readonly]="true" [rows]="5" [cols]="30" style="max-width:initial!important;width:100%!important;height:75px !important;margin-bottom:10px;" name="message" id="message" placeholder="Enter your text here"
                required> {{c.comment}} </textarea>
            </li>
          </ul>
        </div>
      </div>
    </form>
    <p-footer>
      <div style="margin:10px 0 0 0;padding:10px;">
        <button class="button-inaction" type="button" pButton (click)="widgetDialog = false" label="Close" icon="fa fa-close"></button>
        <button class="button-negative" *ngIf="widget.id" type="button" pButton (click)="deleteWidget(widget)" label="Delete" icon="fa fa-close"></button>
        <button class="button-action" *ngIf="!widget.id" type="button" pButton (click)="addWidget(widget)" [disabled]="!widgetForm.form.valid" label="Add" icon="fa fa-check"></button>
        <button class="button-action" *ngIf="widget.id" type="button" pButton (click)="updateWidget()" [disabled]="!widgetForm.form.valid" label="Update" icon="fa fa-check"></button>

      </div>
    </p-footer>
  </p-dialog>


  <!-- dialog for adding new Lane -->
  <p-dialog header="Add New Lane" [(visible)]="laneDialog" [responsive]="true" [modal]="true" [style]="DialogStyle40">
    <div class="p-col-12 p-md-3 p-lg-3">
      <label>Lane Name*</label>
    </div>
    <div class="p-col-12 p-md-9 p-lg-9">
      <input type="text" [(ngModel)]="container.lane" pInputText id="lane" name="lane">
      <br />
      <p-checkbox binary="true" [(ngModel)]="container.taskCompletion" name="taskCompletion" id="taskCompletion"></p-checkbox> Does this lane indicate Task Completed?
    </div>
    <p-footer>
      <div style="margin-top:10px;">
        <button pButton class="button-inaction" type="button" (click)="laneDialog = false" label="Close" icon="fa fa-close"></button>
        <button pButton class="button-action" type="button" (click)="addContainer()" label="Add" icon="fa fa-check"></button>
      </div>
    </p-footer>
  </p-dialog>
</div>
